'use es6';

import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
import { startOf } from 'reporting-data/lib/dateUtils';
import { STANDARD_TO_FISCAL_YEAR_DATE_RANGE } from 'reporting-data/constants/dateRangeTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const DateRangeLabel = ({
  dateRange,
  useFiscalYear = false
}) => {
  const originalDateRangeType = dateRange.get('rangeType');
  const rangeType = useFiscalYear ? STANDARD_TO_FISCAL_YEAR_DATE_RANGE[originalDateRangeType] || originalDateRangeType : originalDateRangeType;
  const rollingDays = dateRange.get('rollingDays');
  const startDate = dateRange.get('startDate');
  const endDate = dateRange.get('endDate');
  const entireCurrentUnit = dateRange.get('entireCurrentUnit');
  const date = dateRange.get('date');
  const options = {
    count: Number(rollingDays) ? parseInt(rollingDays, 10) : 0,
    start: I18n.moment.utc(startDate).format('l'),
    end: I18n.moment.utc(endDate).format('l'),
    date: I18n.moment.utc(date).format('l')
  };
  let labelKey = `DateRangePicker.readOnly.${rangeType}`;
  if (rangeType.includes('THIS')) {
    labelKey += entireCurrentUnit ? '.entire' : '.toDate';
  } else if (rangeType.includes('CUSTOM_')) {
    const [, frequency] = rangeType.split('_');
    const customDate = startOf({
      date: I18n.moment.portalTz(date),
      frequency
    });
    const formatStr = frequency === 'MONTH' ? 'MMMM' : '[Q]Q';
    return frequency === 'YEAR' ? customDate.format('YYYY') : customDate.format(`${formatStr} YYYY`);
  }
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: labelKey,
    options: options
  });
};
DateRangeLabel.propTypes = {
  dateRange: PropTypes.instanceOf(ImmutableMap).isRequired,
  useFiscalYear: PropTypes.bool
};
export default DateRangeLabel;